<template>
  <MenuItemModalWrapper
    :show="true"
    :current-item="currentItem"
    :form-loading="formLoading"
    :form-errors="formErrors"
    @close="$emit('cancel')"
    @submit="$emit('submit', $event)"
  />
</template>

<script setup lang="ts">
import MenuItemModalWrapper from './MenuItemModalWrapper.vue';
import type { MenuItem } from '@/types/menu';

defineProps<{
  currentItem: MenuItem | null;
  formLoading: boolean;
  formErrors: Record<string, string>;
}>();

defineEmits<{
  submit: [formData: Omit<MenuItem, 'id'>];
  cancel: [];
}>();
</script>
